import { ParsedUrlQuery } from "querystring";
import { ServicePayload } from "../booking";

type ServiceFromQs = Partial<ServicePayload>;

export const getDetailsFromQs = (
  query: ParsedUrlQuery,
): Readonly<ServiceFromQs> => {
  const {
    state,
    first_name,
    last_name,
    name,
    email,
    phone,
    gender,
    address,
    zip,
    city,
    promo,
    insurance,
    dob,
  } = query;

  let first = "";
  let last = "";
  if (name && !first_name && !last_name) {
    const longName = String(name).split(" ");
    first = name ? longName.slice(0, longName.length - 1).join(" ") : "";
    last = name ? longName[longName.length - 1] : "";
  }

  return {
    state: state ? String(state) : "",
    selected_state: state ? String(state) : "",
    first_name: first_name ? String(first_name) : first ?? "",
    last_name: last_name ? String(last_name) : last ?? "",
    email: email ? String(email) : "",
    phone: phone ? String(phone) : "",
    gender: gender
      ? String(gender).charAt(0).toUpperCase() + String(gender).slice(1)
      : "",
    street: address ? String(address) : "",
    zip: zip ? String(zip) : "",
    promo: promo ? String(promo) : "",
    couponCode: promo ? String(promo) : "",
    city: city ? String(city) : "",
    insurance: insurance ? String(insurance) : "",
    country: "USA",
    dob: dob ? String(dob) : "",
  };
};
